/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";

//Redux Imports
import {
  addNewLabel,
  ReimburseApproveAccount,
  ReimburseRejectAccount,
  ReimburseViewAll,
  removeNewLabel,
  viewAccountDetailR,
} from "../../../../redux/features/accounts/ReimburseAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { requestTxnReject } from "../../../../redux/features/reimbursementRequest/index.js";
import { ReimbursementTxnDeniedApproval } from "../../../../redux/features/reimbursementTransaction/index.js";

//Compoenents Imports
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import ReimbursementAccountDetailsPopup from "../../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import Loader from "../../../../components/Loader/Index";
import UserDetailsPopup from "../../../../components/Settings/User/UserDetailsPopup/index.jsx";

//utils Imports
import ICONS from "../../../../assets/Icons/index.js";
import TEXT from "../../../../utils/globalText.js";
import useServiceChecker from "../../../../components/ServiceChecker/index.jsx";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import ReimbursementRequestViewAll from "../../../ReimbursementRequest/ReimbursementRequestViewAll/index.jsx";
import ReimbursementTransactionsViewAll from "../../../Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll/index.jsx";
import ReimbursementAccountViewAll from "../ReimbursementAccountViewAll/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import UseHandleScroll from "../../../../hooks/useHandleScroll.js";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const formatName = (name) => {
  if (!name) return "";
  return name
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
const ReimbursementAccountApproval = () => {
  const filterRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const dropdownRef = useRef(null);
  const [ensureAny] = useServiceChecker();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const {
    reimbursementRequestViewAllData,
    reimbursementRequestViewAllLoading,
  } = useSelector((state) => state.reimbursementRequest);

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  const {
    ReimburseViewAllData,
    ReimburseApproveData,
    viewAccountDetailLoading,
  } = useSelector((state) => state.ReimburseAccount);

  const services = useSelector((state) => state.refreshToken.services);
  const categories = useSelector(
    (state) => state?.sharedResources.categoriesData?.categories,
  );
  const { reimbursementTxnViewAllLoading, reimbursementTxnViewAllData } =
    useSelector((state) => state?.reimbursementTransaction);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  //usestate

  const [allAccounts, setAllAccounts] = useState([]);
  const [seachType, setSearchtype] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [RequestRejectAll, setRequestRejectAll] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [loading, setLoading] = useState({});
  const [labels, setLabels] = useState([]);
  const [labelid, setlableid] = useState([]);
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat"),
  );
  const [currentPage, setCurrentPage] = useState(
    Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [showLoader, setShowLoader] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [openAssociateModal, setOpenAssociateModal] = useState(false);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [panNumber, setPanNumber] = useState(searchParam.get("pan") || "");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [isIfsc, setIsIfsc] = useState(searchParam.get("ifsc") || "");
  const [accountNumber, setAccountNumber] = useState(
    searchParam.get("accountNo") || "",
  );
  const [reimbursementAccountId, setReimbursementAccountId] = useState("");
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [active, setActive] = useState("");
  const [inputData, setInputData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [labelPopupAccounts, setLabelPopupAccounts] = useState([]);
  const labelActionDispatchedRef = useRef(false);
  const [userpopup, setUserpopup] = useState(false);
  const [userid, setUserid] = useState("");

  const [declineReason, setDeclineReason] = useState("");
  const [currentBtnClicked, setCurrentBtnClicked] = useState({});
  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const accumulatedDataRef = useRef([]);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
    handleSearchParams("pageno", page);
  };
  const searchBarRefAcc2 = useRef(null);
  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };

  const [associatePopupData, setAssociatePopupData] = useState({
    pan: "",
    ifsc_code: "",
    bank_acc_no: "",
    id: "",
    name: "",
  });
  const [startDateFilter, setStartDateFilter] = useState(dateFromUrl.start);
  const [endDateFilter, setEndDateFilter] = useState(dateFromUrl.end);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [showCategory, setShowCategory] = useState(false);
  const [associateType, setAssociateType] = useState("");
  const [remPan, setRemPan] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [remIFSC, setIFSC] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [searchPanText, setSearchPanText] = useState("");
  const [ReimburseAccountDetailpop, setReimburseAccountDetailpop] =
    useState(false);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(!!(startDateFilter && endDateFilter));
  };

  useEffect(() => {
    updateIsFilterApplied();
  }, [startDateFilter, endDateFilter]);

  const filtercondition = searchUserText || isFilterApplied || showSearchBar;

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(currentPage);
    setCurrentPage(nextPage);
    handleSearchParams("pagesize", value);
    handleSearchParams("pageno", nextPage);
    toggleDropdown();
  };

  const filteredData = accumulatedData;

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
    setShowRejectPopup(false);
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    setlableid([]);
    setLabelPopupAccounts([]);
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids[0]?.errors ??
      res?.payload ??
      "";
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelid);
    const res = await dispatch(
      addNewLabel({ record_ids: recordIds, labels: labelsToAssign }),
    );

    if (addNewLabel.fulfilled.match(res)) {
      // 1. Synchronous UI patch for the modal
      setLabelPopupAccounts((prev) =>
        prev.map((acc) => ({
          ...acc,
          labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
        })),
      );

      // 2. Synchronous UI patch for the background cards so they reflect instantly
      setAllAccounts((prev) =>
        prev.map((acc) => {
          if (recordIds.includes(acc.id)) {
            return {
              ...acc,
              labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
            };
          }
          return acc;
        }),
      );

      // 3. Fire & Forget background sync
      fetchData(true);

      toast.dismiss();
      CommonToast({
        text:
          whichToast === "new"
            ? "New label assigned successfully."
            : "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData(true);
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    return addNewLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelid);
    const res = await dispatch(
      removeNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel.fulfilled.match(res)) {
      // 1. Synchronous UI patch for the modal
      setLabelPopupAccounts((prev) =>
        prev.map((acc) => ({
          ...acc,
          labels: (acc.labels || []).filter(
            (l) => !labelsToUnassign.includes(l),
          ),
        })),
      );

      // 2. Synchronous UI patch for the background cards
      setAllAccounts((prev) =>
        prev.map((acc) => {
          if (recordIds.includes(acc.id)) {
            return {
              ...acc,
              labels: (acc.labels || []).filter(
                (l) => !labelsToUnassign.includes(l),
              ),
            };
          }
          return acc;
        }),
      );

      // 3. Fire & Forget background sync
      fetchData(true);

      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData(true);
    }

    return removeNewLabel?.fulfilled?.match(res) ? true : false;
  };

  const onClose = () => {
    setShowRejectPopup(false);
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Account approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const handleApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    const data = await dispatch(ReimburseApproveAccount(id));

    if (!!data?.payload?.errors?.user_unauthorized?.length) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "RAAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;
      if (errors?.reimbursement_accounts?.[0]) {
        errorMessage = errors.reimbursement_accounts[0];
      } else if (errors?.bank_account_number?.[0]) {
        errorMessage = errors.bank_account_number[0];
      } else if (data?.payload?.errors === "false") {
        errorMessage = errors?.category?.[0];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data?.payload.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data?.payload.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data?.payload.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.reimbursement_accounts?.[0]) {
              message = errors.reimbursement_accounts[0];
            } else if (errors?.bank_account_number?.[0]) {
              message = errors.bank_account_number[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data.payload.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        handleApprovalToastSuccess();
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const openReimbursementAccountDetailsPopup = async (id) => {
    setReimbursementAccountId(id);
    setShowAccountModal(true);
  };

  const closeReimbursementAccountDetailsPopup = () => {
    setShowAccountModal(false);
  };

  const openTxnPopup = (id, acc_Name) => {
    setAssociatePopupData(() => {
      return {
        id: id,
        name: acc_Name,
      };
    });
  };

  const handleInputChange = (event) => {
    const value = event?.target?.value || "";

    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const fetchData2 = async () => {
    let response;
    let data = [];

    switch (active) {
      case "Category":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        break;
      default:
        break;
    }
  };

  const handleClearFilters = () => {
    setAllBeneTxnAccountsLoading(true);
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setCurrentCategory("");
    setPanNumber("");
    setAccountNumber("");
    setIsIfsc("");
    setLabelSearchText([]);
    setSearchUserTextDebounce("");
    setSearchUserText("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${dropdownOptions[0]}`,
      },
      { replace: true },
    );
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowPopup(false);

    const accountInfo = await dispatch(viewAccountDetailR({ id: deniedId }));

    if (
      accountInfo?.payload?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_transactions === "Y"
    ) {
      setShowRejectPopup(true);
    } else if (
      accountInfo?.payload?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_requests === "Y"
    ) {
      setRequestRejectAll(true);
    } else {
      handleConfirm(id, AccountIdData);
    }
  };

  // Account Reject method
  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    const result = await dispatch(
      ReimburseRejectAccount({ id, AccountIdData }),
    );
    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (result?.payload?.status === false) {
      setCurrentBtnClicked((c) => {
        return {
          ...c,
          [deniedId]: "none",
        };
      });
      let error_msg = "";

      if (result?.payload?.errors?.reimbursement_accounts?.[0]) {
        error_msg = result?.payload?.errors?.reimbursement_accounts[0];
      } else if (result?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = result?.payload?.errors?.bank_account_number[0];
      } else if (result?.payload?.status === false) {
        error_msg = result?.payload?.errors?.category?.[0];
      } else {
        error_msg = "An unknown error occurred.";
      }

      const updatedData = allAccounts?.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? "error" : "pending",
            rejected_on: "",
            rejected_by_name: "",
            rejection_reason: AccountIdData,
            error: "true",
            message: error_msg,
            pending_reimbursement_transactions: "N",
          };
        }
        return item;
      });
      updateAllAccounts(updatedData);
      setShowLoader(false);
      setShowPopup(false);
      setDeclineReason("");
      onClose();
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } else {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            approval_status: "rejected",
            rejected_on:
              result?.payload?.reimbursement_accounts?.[0]?.rejected_on ?? "",
            rejected_by_name:
              result?.payload?.reimbursement_accounts?.[0]?.rejected_by_name ??
              "",
            rejection_reason: AccountIdData,
            error: "false",
            message: "",
            pending_reimbursement_transactions: "N",
          };
        }
        return item;
      });
      updateAllAccounts(updatedData);
      setShowLoader(false);
      setDeclineReason("");
      onClose();
      setShowPopup(false);
      CommonToast({
        text: "Account rejected successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setCurrentBtnClicked((c) => {
        return {
          ...c,
          [deniedId]: "none",
        };
      });
    }
  };

  // Reject reimbursement transactions
  const handleRejectReimbursementTxn = async () => {
    setShowLoader(true);

    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementTxnViewAllLoading &&
      reimbursementTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        ReimbursementTxnDeniedApproval({ id: id2, AccountIdData }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      setCurrentBtnClicked((item) => {
        return {
          ...item,
          [deniedId]: "none",
        };
      });
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setShowRejectPopup(false);

      setTimeout(() => {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSemiMid);

      const updatedData = allAccounts?.map((item) => {
        if (item.id === associatePopupData?.id) {
          return {
            ...item,
            pending_reimbursement_transactions: "N",
          };
        }
        return item;
      });

      updateAllAccounts(updatedData);
      setCurrentBtnClicked((item) => {
        return {
          ...item,
          [deniedId]: "none",
        };
      });
      const accountInfo = await dispatch(viewAccountDetailR({ id: deniedId }));
      if (
        accountInfo?.payload?.reimbursement_accounts?.[0]
          ?.pending_reimbursement_requests === "Y"
      ) {
        setRequestRejectAll(true);
      } else {
        if (associateType === "rejectAccount") {
          handleConfirm(deniedId, declineReason);
        }
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setTimeout(() => {
      setShowRejectPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
    setShowPopup(false);
  };

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };
  const hasAnyFilter =
    Boolean(currentCategory?.length) ||
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(isIfsc) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const openAssociatedAccountsFound = (ifsc_code, acc_no, pan_no, id) => {
    setAssociatePopupData((prev) => {
      return {
        ...prev,
        ifsc_code: ifsc_code,
        bank_acc_no: acc_no,
        id: id,
        pan: pan_no,
      };
    });
    setRemPan(pan_no);
    setOpenAssociateModal(true);
  };

  const handleRejectRequestTxn = async () => {
    setShowLoader(true);
    // setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementRequestViewAllLoading &&
      reimbursementRequestViewAllData?.requests?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementRequestViewAllData?.requests?.map(
            (data) => data?.request_id,
          )
        : [];

    UniversalRefreshToast("Rejecting requests");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        requestTxnReject({ request_ids: id2, AccountIdData }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementRequest";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      setCurrentBtnClicked((c) => {
        return {
          ...c,
          [deniedId]: "none",
        };
      });
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setShowRejectPopup(false);
      setRequestRejectAll(false);

      setTimeout(() => {
        CommonToast({
          text: "Requests rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);
      setShowPopup(false);
      const updatedData = allAccounts?.map((item) => {
        if (item.id === associatePopupData?.id) {
          return {
            ...item,
            pending_reimbursement_requests: "N",
          };
        }
        return item;
      });

      updateAllAccounts(updatedData);
      if (associateType === "rejectAccount") {
        handleConfirm(associatePopupData?.id, AccountIdData);
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
    setShowPopup(false);
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  const fetchData = async (isSilent = false) => {
    try {
      // Only trigger the loader if it's not a background update
      if (!isSilent) {
        setAllBeneTxnAccountsLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        approval_status: "pending",
      };

      if (currentCategory !== "") {
        queryParams.category = currentCategory;
      }
      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter &&
        endDateFilter &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = startDateFilter;
        queryParams.end_date = endDateFilter;
      }
      if (accountNumber !== "") {
        queryParams.bank_account_no = accountNumber;
      }
      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (!!LabelSearchText?.length) {
        queryParams.labels = LabelSearchText;
      }
      if (isIfsc !== "") {
        queryParams.ifsc = isIfsc;
      }

      const response = await dispatch(ReimburseViewAll(queryParams));

      const newData = (response?.payload?.reimbursement_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
      setLabels((prev) => {
        const incoming = response?.payload?.summary?.available_labels || [];
        const merged = [...new Set([...(prev || []), ...incoming])];
        return merged;
      });

      const rawData = response?.payload?.reimbursement_accounts || [];
      setAccumulatedData(rawData);
      accumulatedDataRef.current = rawData;
    } catch (error) {
      console.error("Error fetching reimbursement accounts:", error);
    } finally {
      // Always ensure the loader is turned off at the end
      setAllBeneTxnAccountsLoading(false);
    }
  };
  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      const startTs = convertDate(start);
      const endTs = convertDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      handleSearchParams("date", `${startTs},${endTs}`);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      handleSearchParams("date", "");
    }
  };

  const onMount = () => {};

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    fetchData();
  }, [
    markerData,
    dispatch,
    currentPage,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    searchUserText,
    isIfsc,
    currentCategory,
    LabelSearchText,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {openAssociateModal && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal">
          <div className="top-top-base absolute h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <LargePopupRedirect
            headerTitle="Associated accounts"
            headersubtext="The accounts listed below are linked to the selected reimbursement account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setOpenAssociateModal(false);
              setRemPan();
              setRemAccount("");
              setIFSC("");
              setActiveType("pan");
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            confirmbtnrequired={true}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
            ispanbankRequired={true}
            togglepan={() => {
              setActiveType("pan");
              setRemPan(associatePopupData?.pan);
              setRemAccount("");
              setIFSC("");
              setSearchPanText(associatePopupData?.pan);
            }}
            toggleBank={() => {
              setActiveType("bank");
              setRemPan("");
              setRemAccount(associatePopupData?.bank_acc_no);
              setIFSC(associatePopupData?.ifsc_code);
              setSearchPanText(associatePopupData?.bank_acc_no);
            }}
          >
            <ReimbursementAccountViewAll
              type={"ReimbursementAcc"}
              remPan={remPan}
              remAccount={remAccount}
              remIFSC={remIFSC}
              activeType={activeType}
              searchPanText={searchPanText}
              currentAccountDetails={associatePopupData}
              setOpenBeneAssociate={setOpenAssociateModal}
            />
          </LargePopupRedirect>
        </div>
      )}

      {RequestRejectAll && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center justify-center z-z-index-modal">
            <div className="top-top-base absolute h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
            <LargePopupRedirect
              headerTitle="Pending requests found"
              headersubtext="The following requests are linked and need to be rejected before rejecting this account."
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              fullviewisDisabled={false}
              fullviewenabledTextColor="var(--text-primary)"
              fullviewenabledBgColor="var(--primary-nav)"
              fullviewhoverOption="white"
              fullviewicon={ICONS?.REDIRECT}
              fullviewdisabledBgColor="var(--text-disabled)"
              closeiconbtnType="button"
              closeiconhandleFunction={() => {
                setDeclineReason("");
                setShowLoader(false);
                setCurrentBtnClicked((item) => {
                  return {
                    ...item,
                    [deniedId]: "none",
                  };
                });
                setRequestRejectAll(false);
              }}
              closeiconisDisabled={false}
              closeiconenabledBgColor="var(--primary-nav)"
              closeicondisabledBgColor="var(--text-disabled)"
              closeiconhoverOption="white"
              closeicon={ICONS?.CLOSE}
              bottomHeaderTextNeed={true}
              bottomHeaderText={
                "To reject the account, please reject the requests listed above by clicking the “Reject all” button. The requests will get rejected with the provided rejected reason."
              }
              isbottomSectionneed={true}
              btnText={"Reject all"}
              confirmbtnrequired={true}
              handleFunction={() => {
                if (associateType === "RejectAllRequestTxn") {
                  setShowPopup(true);
                } else {
                  handleRejectRequestTxn();
                }
              }}
              isLoaderNeeded={true}
              isLoading={showLoader ? true : false}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
            >
              <ReimbursementRequestViewAll
                type={"requestViewallPopup"}
                alert={"alertpopup"}
                flow={"RequestRejectAll"}
                TxnHistoryid={associatePopupData?.id}
                TxnHistoryAccountName={associatePopupData?.name}
                closeReimburseTxnDetailsModal={() => {
                  setRequestRejectAll(false);
                }}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}

      {ReimburseAccountDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReimbursementAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setReimburseAccountDetailpop(false);
            }}
            reimburse_account_id={associatePopupData?.id}
            type={"reimburseacc_details"}
          />
        </div>
      )}

      {/* Reject reimbursement transactions associated to the Account */}
      {showRejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal">
          <div className="top-top-base absolute h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setShowRejectPopup(false);
              setDeclineReason("");
              setShowLoader(false);
              setCurrentBtnClicked((item) => {
                return {
                  ...item,
                  [deniedId]: "none",
                };
              });
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (associateType === "ReimbursementTxn") {
                setShowPopup(true);
              } else {
                handleRejectReimbursementTxn();
              }
            }}
            enabledBgColor={"var(--negative-act)"}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <ReimbursementTransactionsViewAll
              TxnHistoryid={associatePopupData?.id}
              alert={"alertpopup"}
              type={"reimburse_txnViewAll_popup"}
              flow="reimburse_txnViewAll_popup_reject"
              associateType={associateType}
              seachType={seachType}
              closeRejectAllTxn={handleClosePopup}
              TxnHistoryAccountName={associatePopupData?.name}
            />
          </LargePopupRedirect>
        </div>
      )}

      {userpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex">
          <div className="top-top-base absolute h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <UserDetailsPopup
            User_account_id={userid}
            type={"User_details"}
            closeBeneAccountDetailModal={() => {
              setUserpopup(false);
            }}
          />
        </div>
      )}

      {/* Label Popup */}
      {isLabelPopupOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="fixed left-left-base w-width-full top-top-base h-height-full flex items-center justify-center z-max-zindex"
        >
          <div className="top-top-base absolute h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={labelPopupAccounts}
            onClose={handleClose}
            loading={allBeneTxnAccountsLoading}
            setLoading={setAllBeneTxnAccountsLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {/* Decline Reason Popup */}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex">
          <div className="top-top-base absolute h-full w-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <SmallPopupWithBulletPoints
            headerTitle={TEXT?.REJECT_ACCOUNT}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
            noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
            isTextInputField={true}
            inputPlaceholder="Reason"
            inputAdornment={false}
            inputFontKind="big"
            subtextwithbullet="Y"
            bulletPoints={[
              "New requests and transactions cannot be created for this account.",
              "Before rejecting this account, reject all associated transactions and requests.",
              "Users can edit the rejected account to update details.",
            ]}
            inputVariant={computeVariant(declineReason, false)}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputIsFullWidth={true}
            btnOneText={TEXT?.CANCEL}
            btnOneHandleFunction={() => {
              setCurrentBtnClicked((item) => {
                return {
                  ...item,
                  [deniedId]: "none",
                };
              });
              if (!showLoader) {
                setShowPopup(false);
                setDeclineReason("");
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT?.REJECT}
            btnTwoHandleFunction={() => {
              if (associateType === "ReimbursementTxn") {
                handleRejectReimbursementTxn();
              } else if (associateType === "RejectAllRequestTxn") {
                handleRejectRequestTxn();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason?.length < GlobalConfiguration?.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {/* Reimbursement Account details in a modal */}
      {showAccountModal && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-custom-backdrop  /bg-opacity-dark-opacity">
          <ReimbursementAccountDetailsPopup
            reimburse_account_id={reimbursementAccountId}
            type={"reimburseacc_details"}
            closeBeneAccountDetailModal={closeReimbursementAccountDetailsPopup}
            showCategory={showCategory}
          />
        </div>
      )}

      {/* Entire page */}
      <div className={` h-screen overflow-hidden flex flex-col`}>
        <div
          className={`relative z-z-index-overlay ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} min-h-0 Qmd:min-h-navbar-breadcrumb-height`}
        ></div>
        <div className=" w-full relative z-z-index-header lg:px-padding-base  flex items-center justify-end m-auto ">
          <TopNavComponent
            direction={direction}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allBeneTxnAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search reimbursement account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setSearchUserText(val);
                    handleSubmit("search", val);
                  },
                  isDropdown: false,
                  isDisabled: allBeneTxnAccountsLoading,
                },
                {
                  name: "Account number",
                  short_name: "Reimb. A/c",
                  isMulti: false,
                  value: accountNumber,
                  setValue: (val) => {
                    setAccountNumber(val);
                    handleSubmit("accountNo", val);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value: isIfsc.toUpperCase(),
                  setValue: (val) => {
                    setIsIfsc(val);
                    handleSubmit("ifsc", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber.toUpperCase(),
                  setValue: (val) => {
                    setPanNumber(val);
                    handleSubmit("pan", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      categories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    setCurrentCategory(val);
                    handleSubmit("category", val);
                    handleSubmit("dispCat", c);
                  },
                  isDropdown: true,
                  isDisabled: allBeneTxnAccountsLoading ? true : false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setLabelSearchText(val);
                    handleSubmit(
                      "label",
                      Array.isArray(val) ? val.join(",") : val,
                    );
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allBeneTxnAccountsLoading,
                },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => handleDateChange(date),
                },
              ],
              isFilterClearAllDisabled: !(startDateFilter && endDateFilter),
              isSearchClearAllDisabled: !(
                currentCategory !== "" ||
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration?.lengthCheckZero ||
                isIfsc !== "" ||
                searchUserText !== "" ||
                accountNumber !== ""
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: allBeneTxnAccountsLoading,
              setLoading: (e) => {},
              isShowFilter: true,
            }}
          />
        </div>
        <div
          className={`flex-1 flex flex-col overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
        >
          {showInnerSearchBar && (
            <div className="absolute top-top-base left-left-base bg-PopUp-BackDrop w-full h-full  z-z-index-content opacity-dark-opacity" />
          )}
          <div
            style={{
              paddingBottom:
                ReimburseViewAllData?.summary?.pending_accounts_count ===
                  undefined && "var(--padding-md)",
            }}
            className={`relative ${showInnerSearchBar ? "flex flex-col items-center pointer-events-none overflow-hidden w-full h-full pb-padding-xl" : " flex flex-col items-center overflow-auto overflow-x-hidden w-full pb-padding-md"} h-full`}
            onScroll={handleScroll}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="loader-container m-auto h-screen justify-center items-center flex">
                <Loader />
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              filtercondition ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className="bene-acc-no-beneaccount-text my-margin-sm">
                  No data found.
                </p>

                {(searchUserText || isFilterApplied || showSearchBar) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={handleClearFilters}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            ) : !!allAccounts?.length ? (
              <div
                className={`scroll flex flex-col  items-center justify-center w-width-full`}
                ref={filterRef}
              >
                <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base  gap-gap-md">
                  {allAccounts?.map((account, index) => {
                    // All categories assigned to account
                    const associatedCategories =
                      account?.all_category_assign === "Y";

                    // Associated account based on PAN or Bank
                    const associatedAccounts =
                      account?.associate_bank === "Y" ||
                      account?.associate_pan === "Y";

                    // Pending transaction for the account
                    const pendingTxn =
                      account?.pending_reimbursement_transactions === "Y";
                    const pendingRequestTxn =
                      account?.pending_reimbursement_requests === "Y";

                    const buildAlerts = () => [
                      ...(associatedCategories !== undefined
                        ? associatedCategories
                          ? [
                              {
                                isLoading: false,
                                text: "All categories are assigned to this account",
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  openReimbursementAccountDetailsPopup(
                                    account?.id,
                                  );
                                  setShowCategory(true);
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: "Checking category assign",
                            },
                          ]),

                      ...(associatedAccounts !== undefined
                        ? associatedAccounts
                          ? [
                              {
                                isLoading: false,
                                text: "Associated accounts are found",
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  openAssociatedAccountsFound(
                                    account?.ifsc_code,
                                    account?.bank_acc_no,
                                    account?.pan_no,
                                    account?.id,
                                  );
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: "Checking associated account",
                            },
                          ]),

                      ...(pendingTxn !== undefined
                        ? pendingTxn
                          ? [
                              {
                                isLoading: false,
                                text: "Pending transactions found",
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  openTxnPopup(account?.id, account?.name);
                                  setShowRejectPopup(true);
                                  setAssociateType("ReimbursementTxn");
                                  setSearchtype("rejectall");
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: viewAccountDetailLoading
                                ? true
                                : false,
                              text: "Checking pending transactions",
                            },
                          ]),

                      ...(pendingRequestTxn !== undefined
                        ? pendingRequestTxn &&
                          account?.approval_status === "pending"
                          ? [
                              {
                                isLoading: false,
                                text: "Pending request found",
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  setRequestRejectAll(true);
                                  setAssociateType("RejectAllRequestTxn");
                                  setSearchtype("rejectall");
                                  setAssociatePopupData((prev) => {
                                    return {
                                      ...prev,
                                      id: account?.id,
                                      name: account?.name,
                                    };
                                  });
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: viewAccountDetailLoading
                                ? true
                                : false,
                              text: "Checking request pending transactions",
                            },
                          ]),
                    ];
                    return (
                      <div
                        key={account.id}
                        className={`w-full ${!index ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            currentBtnClicked?.[account?.id] ?? "none"
                          }
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: account.name,
                                subText: "Account name",
                              },
                              {
                                type: "textSubtext",
                                text: account.email_id,
                                subText: "Email ID",
                              },
                              {
                                type: "textSubtextX2",
                                text: "+91 " + account.contact_no,
                                subText: "Contact number",
                                text1: account?.account_type ?? "New",
                                subText1: "Account",
                              },
                              {
                                type: !account?.reimbursement_user_full_name
                                  ? "textSubtext"
                                  : "cta",
                                text: account?.reimbursement_user_full_name
                                  ? account?.reimbursement_user_full_name
                                  : "Not Linked",
                                subText: "Linked user",

                                onClick: () => {
                                  const s = ensureAny(["VSpecificEmp"]);
                                  if (s.status) {
                                    if (account?.reimbursement_user_full_name) {
                                      setUserpopup(true);
                                      setUserid(account?.reimbursement_user_id);
                                    }
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VSpecificEmp",
                                      },
                                    });
                                  }
                                },
                              },
                            ],

                            [
                              {
                                type: "textSubtext",
                                text: formatName(
                                  account.bank_account_holder_full_name,
                                ),
                                subText: "Bank account holder's name ",
                              },
                              {
                                type: "accountNumber",
                                text: account.bank_acc_no,
                                subText: "Account number",
                                ifsc: account.ifsc_code,
                              },
                              {
                                type: "textSubtext",
                                text: account.ifsc_code,
                                subText: "IFSC code",
                              },
                              {
                                type: "textSubtextX2",
                                text: account.pan_no,
                                subText: "PAN number",
                                text1: account.gstin_detail || "Not given",
                                subText1: "GST number",
                              },
                            ],

                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") ||
                                  "No labels assigned",
                                subText: "Labels",
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setlableid([account?.id]);
                                    setLabelPopupAccounts(
                                      accumulatedData.filter(
                                        (acc) => acc?.id === account?.id,
                                      ),
                                    );
                                    setIsLabelPopupOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                type: "textSubtext",
                                text:
                                  account?.category_ids
                                    ?.map((e) => e.category_name)
                                    .join(", ") || "Not Assigned",
                                subText: "Categories",
                              },
                            ],
                          ]}
                          approveClick={() => {
                            handleApproval(account.id);

                            setCurrentBtnClicked((c) => {
                              return { ...c, [account?.id]: "approve" };
                            });
                          }}
                          rejectClick={() => {
                            handleOpenPopup(account?.id);
                            setSearchtype("rejectall");
                            SetdeniedId(account?.id);
                            openTxnPopup(account?.id, account?.name);
                            setAssociateType("rejectAccount");
                            setCurrentBtnClicked((c) => {
                              return { ...c, [account?.id]: "reject" };
                            });
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={
                            account.approval_status === "pending" &&
                            !loading[account.id]
                              ? () => {
                                  setReimburseAccountDetailpop(true);
                                  setAssociatePopupData((prev) => ({
                                    ...prev,
                                    id: account?.id,
                                  }));
                                }
                              : undefined
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            ReimburseApproveData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            ReimburseApproveData &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            ReimburseApproveData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            ReimburseApproveData &&
                            !loading[account.id]
                              ? ICONS?.APPROVED_GREEN_LINEAR
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? ICONS?.REJECTED_RED
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              ReimburseApproveData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              ReimburseApproveData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => {
                                  navigate(
                                    `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${account.id}`,
                                    {
                                      state: {
                                        isViewAll:
                                          location.pathname.includes(
                                            "view_all",
                                          ),
                                      },
                                    },
                                  );
                                }
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : noTransactionsFromAPI ? (
              <div className=" flex flex-col justify-center items-center m-auto">
                <div className=" flex flex-col items-center justify-end">
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="No accounts found"
                    className={
                      "w-graphic-width-md h-graphic-rectangle-height-md"
                    }
                  />
                </div>

                <div className=" flex flex-col items-center text-font-sm font-normal mt-margin-sm text-text-primary">
                  <p>There are no pending accounts for your approval.</p>
                </div>
                <div className=" mt-margin-sm">
                  {" "}
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Reimbursement account dashboard"
                    btnType="button"
                    handleFunction={() =>
                      navigate("/reimbursement_account_dashboard")
                    }
                    enabledTextColor="var(--text-primary)"
                  />
                </div>
              </div>
            ) : noResultsAfterFilter ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className="bene-acc-no-beneaccount-text my-margin-sm">
                  No data found.
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  btnType="button"
                  handleFunction={handleClearFilters}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : null}

            <div
              className={`w-width-full ${allBeneTxnAccountsLoading && "hidden"} bottom-bottom-base fixed ${showInnerSearchBar ? " " : "shadow-box-shadow-top opacity-base-opacity"} ${
                (accumulatedData?.length &&
                  !filteredData?.length &&
                  !loading) ||
                noResultsAfterFilter
                  ? "hidden"
                  : "block"
              }  bg-primary-nav  `}
            >
              <div className={`relative`}>
                {showInnerSearchBar && (
                  <div className="absolute top-top-base left-left-base bg-PopUp-BackDrop w-full h-full  z-z-index-overlay opacity-dark-opacity" />
                )}
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`h-pagination-height flex-shrink-0 
         ${
           (accumulatedData?.length && !filteredData?.length && !loading) ||
           noResultsAfterFilter
             ? "hidden"
             : "block"
         }
          `}
        ></div>
      </div>
    </>
  );
};

export default ReimbursementAccountApproval;
